<div class="cookie-consent-wrapper" *ngIf="showBanner">
    <div class="cookie-consent-banner">
        <div class="cookie-content">
            <div class="cookie-icon">
                <i class='bx bx-cookie'></i>
            </div>
            <div class="cookie-text">
                <h5 class="cookie-title">Çerez Kullanımı</h5>
                <p class="cookie-description">
                    Web sitemizde size en iyi deneyimi sunabilmek için çerezler kullanıyoruz.
                    Sitemizi kullanmaya devam ederek çerez kullanımını kabul etmiş olursunuz.
                    <a href="/gizlilik" target="_blank" class="cookie-link">Gizlilik Politikası</a>
                </p>

                <div class="cookie-details" *ngIf="showDetails">
                    <div class="cookie-category">
                        <strong>Zorunlu Çerezler:</strong>
                        <p>Web sitesinin düzgün çalışması için gerekli olan çerezlerdir. Bu çerezler olmadan site
                            çalışmaz.</p>
                    </div>
                    <div class="cookie-category">
                        <strong>Analitik Çerezler:</strong>
                        <p>Ziyaretçilerin siteyi nasıl kullandığını anlamamıza yardımcı olan çerezlerdir. Bu bilgiler
                            anonim olarak toplanır.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="cookie-actions">
            <button class="btn-details" (click)="toggleDetails()">
                {{ showDetails ? 'Detayları Gizle' : 'Detaylar' }}
            </button>
            <button class="btn-necessary" (click)="acceptNecessary()">
                Sadece Gerekli
            </button>
            <button class="btn-accept" (click)="acceptAll()">
                Tümünü Kabul Et
            </button>
        </div>
    </div>
</div>